export const building = {
  namespaced: true,
  state: {
    overviewSearch: null,
    facilitiesSearch: null,
    rolesSearch: null,
    cardView: true
  }, 
  getters: {
    overviewSearch: state => state.overviewSearch,
    facilitiesSearch: state => state.facilitiesSearch,
    rolesSearch: state => state.rolesSearch,
    cardView: state => state.cardView
  },
  mutations: {
    storeBuildingOverviewSearch(state, search) {
      state.overviewSearch = search;      
    },
    storeFacilitiesSearch(state, search) {
      state.facilitiesSearch = search;    
    },
    storeRolesSearch(state, search) {
      state.rolesSearch = search;      
    },
    storeCardViewState(state, search) {
      state.cardView = search;
    },
  }
}
